/**
 * @description: 订台业绩汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="dh-report">
        <div class="dh-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="dhTime">
                        <input type="text" class="form-control laydate-icon" v-model="dhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="dhEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dhShop" data-placeholder="请选择消费门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="hzperf_tit_sel">
                        <option value="">全部</option>
                        <option value="personnel">艺人</option>
                        <option value="user">员工</option>
                        <option value="consumer">散客</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="hzperf_con_val" ref="hzperf_con_val" :placeholder="hzperf_con_phd">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="dh_group_type" ref="dh_group_type" @click="dhEnterGroup" readonly disabled>
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dh_charger" data-placeholder="请选择主管" disabled></select>
                </div>
                <!-- <label class="list-label-x">是否剔除免单支付金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dh_is_free">
                        <option value="-1">否</option>
                        <option value="1">是</option>
                    </select>
                </div>
                <label class="list-label-y">是否剔除会员卡支付金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dh_is_vip">
                        <option value="-1">否</option>
                        <option value="1">是</option>
                    </select>
                </div> -->
                <label class="list-label-7">需剔除金额类型:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请选择需要剔除金额的支付类型" @click="openExcludePayPlatform" v-model="excludePayPlatform_str"/>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getDhList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getDhExportSet">导出</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="dh_list_table">
                <el-table-column prop="group_name" label="组别"></el-table-column>
                <el-table-column prop="book_admin_name" label="订台人"></el-table-column>
                <el-table-column prop="book_admin_number" label="订台人工号"></el-table-column>
                <el-table-column prop="director_name" label="主管"></el-table-column>
                <el-table-column prop="amount" label="业绩"></el-table-column>
                <el-table-column prop="performance" label="业绩指标"></el-table-column>
                <el-table-column prop="book_num" label="订台数"></el-table-column>
                <el-table-column prop="bill_amount" label="账单实收总额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
						<span class="text-blue" @click="setPageParams(scope.row)">详情</span>
					</template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-2">业绩:</label>
                    <div class="list-total">{{dh_total_amount}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dh_list_page"
                    :total="dh_list_total"
                    @current-change="getDhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="dhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='dhExport_allcheck' @click='dhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="book_admin_name">
                            <label>订台人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="book_admin_number">
                            <label>订台人工号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="amount">
                            <label>业绩</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="performance">
                            <label>业绩指标</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="book_num">
                            <label>订台数</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dhExport_checkModel' value="bill_amount">
                            <label>账单实收金额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='dhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='dhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="dh-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="dh_group_name">
                <img src="../../../assets/images/group_search.png" @click="getDhGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='dh_group_allcheck' @click='groupDhCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in dh_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='dh_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="dhGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="dhGroupSub()">确定</button>
            </div>
        </div>
        <!-- 支付金额类型弹窗 -->
        <div class="pay-platform-pop" ref="pay_platform_pop">
            <el-checkbox :indeterminate="checkAllFlag" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="exclude_pay_platform" @change="handleCheckedPayPlatformChange">
                <el-checkbox v-for="item in excludePayPlatform" :label="item.id" :value="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                dh_dm_menu: {},
                dhStartTime: "",
                dhEndTime: "",
                hzperf_field: "",
                hzperf_con_phd: "请输入订台人姓名",
                hzperf_con_val: "",
                dh_charger_type: '',
                dh_group_type: "",
                dh_group_allcheck: false,
                dh_c_group_allcheck: false,
                dh_group_checkboxModel: [],
                c_dh_group_checkboxModel: [],
                dh_group_checkboxData: [],
                dh_group_name: '',
                dh_list_table: [],
				dh_list_page: 1,
                dh_list_total: 0,
                dh_total_amount: '',
                dhExport_allcheck: false,
                c_dhExport_allcheck: false,
                dhExport_checkModel: [],
                dhExport_checkData: ['group_name', 'book_admin_name', 'book_admin_number', 'director_name', 'amount', 'performance', 'book_num', 'bill_amount'],
                dhExport_type: 1,
                excludePayPlatform: [], // 需要剔除的全部类型
                exclude_pay_platform: [], // 选择的需要剔除的金额类型
                excludePayPlatform_str: '', 
                checkAllFlag: false,
                checkAll: false,
            }
        },
        computed: {
            menunew() {
				return JSON.parse(this.$store.state.menunew)
			}
        },
        watch: {
            dh_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.dh_group_checkboxModel.length >= this.dh_group_checkboxData.length) {
                        this.dh_group_allcheck = true;
                        this.dh_c_group_allcheck = true;
                    } else {
                        this.dh_group_allcheck = false;
                        this.dh_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            hzperf_field: {
                handler: function(val, oldVal) {
                    if(val == '' || val == 'consumer') {
                        $(this.$refs.dh_group_type).prop('disabled', true);
                    } else {
                        $(this.$refs.dh_group_type).prop('disabled', false);
                    }
                },
                deep: true
            },
            dhExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.dhExport_checkModel.length >= this.dhExport_checkData.length) {
                        this.dhExport_allcheck = true;
                        this.c_dhExport_allcheck = true;
                    } else {
                        this.dhExport_allcheck = false;
                        this.c_dhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this

            // 跳转菜单
			_this.getPageMenu();
            // 日期
            _this.dhStartTime = moment().format('YYYY-MM-DD 08:00');
            _this.dhEndTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            _this.innitDate();
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.hzperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                $(_this.$refs.dh_charger).val('').trigger('change');
                $(_this.$refs.dh_charger).prop("disabled", true);
                _this.hzperf_field = $(this).val();
                _this.hzperf_con_val = '';
                $(_this.$refs.hzperf_con_val).prop("disabled", false);
                if(_this.hzperf_field == '') {
                    _this.hzperf_con_phd = '请输入订台人姓名';
                } else if(_this.hzperf_field == 'personnel') {
                    $(_this.$refs.dh_charger).prop("disabled", false);
                    _this.hzperf_con_phd = '请输入艺人姓名';
                } else if(_this.hzperf_field == 'user') {
                    _this.hzperf_con_phd = '请输入员工姓名';
                } else if(_this.hzperf_field == 'consumer') {
                    _this.hzperf_con_phd = '';
                    $(_this.$refs.hzperf_con_val).prop("disabled", true);
                }
                _this.dh_group_checkboxModel = [];
                _this.dh_group_type = '';
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.dhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.dhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 跳转菜单
			getPageMenu: function() {
				this.menunew.forEach(i => {
					if(i.id == '544') {
						i.submenu.forEach(j => {
							if(j.id == '565') {
                                j.submenu.forEach(k => {
                                    if(k.id == '613') {
                                        // 订台业绩明细报表
                                        this.dh_dm_menu = k
                                    }
                                })
							}
						})
					}
				})
			},
			// 跳转参数
			setPageParams(row) {
				const obj = {
					name: 'dm_report',
					params: {
                        start_date: this.dhStartTime,
                        end_date: this.dhEndTime,
                        shop_id: row.shop_id,
                        search_word: row.book_admin_name,
                        book_admin_type: row.book_admin_type,
					}
				}
				this.$emit("pageLink", this.dh_dm_menu, obj)
			},
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.dhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.dhStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.dhEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.dhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    // 主管
                                    $(_this.$refs.dh_charger).val('').trigger('change');
                                    $(_this.$refs.dh_charger).prop("disabled", true);
                                    return;
                                }
                                _this.dh_group_checkboxModel = [];
                                _this.dh_group_type = '';
                                // 主管
                                $(_this.$refs.dh_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                // 需要剔除的支付金额
                                _this.exclude_pay_platform = []
                                _this.excludePayPlatform_str = ''
                                _this.getExcludePayPlatform(e.params.data.id)
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.dhShop).val(data.response.result[1].id).trigger('change');
                            // 主管
                            _this.getChargeData(data.response.result[1].id);
                            // 需要剔除的支付金额
                            _this.getExcludePayPlatform(data.response.result[1].id)
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getDhList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.dh_charger).html('');
                            $(_this.$refs.dh_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.dh_charger_type = e.params.data.type;
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },

            // 获取要剔除的金额类型
            getExcludePayPlatform: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExcludePayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.excludePayPlatform = data.response.result
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



            getDhList(page) {
				const _this = this;

                _this.loading = true;
                _this.dh_list_page = page
				Vue.axios.post('FinanceReport/getAchievementSumList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.dhStartTime,
                            "end_date": _this.dhEndTime,
                            "shop_id": $(_this.$refs.dhShop).val(),
                            "key_word": _this.hzperf_field,
                            "search_word": _this.hzperf_con_val,
                            "group_ids": _this.dh_group_checkboxModel,
                            "director_id": $.trim($(_this.$refs.dh_charger).val()),
                            "director_type": _this.dh_charger_type,
                            "exclude_free_amount": $(_this.$refs.dh_is_free).val() || -1,
                            "exclude_vip_amount": $(_this.$refs.dh_is_vip).val() || -1,
                            "exclude_pay_platform": _this.exclude_pay_platform
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.dh_list_total = Number(res.data.response.result.count);
							_this.dh_total_amount = res.data.response.result.total_amount;
						}
						_this.dh_list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 获取导出设置
            getDhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/achievementSumListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.dhExport_checkModel = data.response.result.export_fields;
                                _this.dhExport_type = data.response.result.export_type;
                            } else {
                                _this.dhExport_checkModel = _this.dhExport_checkData;
                                _this.dhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.dhExport_alert)
                }, function() {
                    _this.exportDhList();
                });
            },
            // 导出字段全选
            dhExportCheckedAll: function() {
                let _this = this;
                _this.dhExport_allcheck = _this.c_dhExport_allcheck;
                if(!_this.dhExport_allcheck) { // 实现全选
                    _this.dhExport_checkModel = [];
                    _this.dhExport_checkData.forEach(function(item) {
                        _this.dhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.dhExport_checkModel = [];
                }
            },
            // 导出订台业绩汇总列表
            exportDhList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.dhShop).val();
                let export_fields = JSON.stringify(_this.dhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/achievementSumListExport?" +
                    "&start_date=" + _this.dhStartTime +
                    "&end_date=" + _this.dhEndTime +
                    "&shop_id=" + shop_id +
                    "&key_word=" + _this.hzperf_field +
                    "&search_word=" + _this.hzperf_con_val +
                    "&group_ids=" + _this.dh_group_checkboxModel +
                    "&director_id=" + $.trim($(_this.$refs.dh_charger).val()) +
                    "&director_type=" + _this.dh_charger_type +
                    "&exclude_free_amount=" + ($(_this.$refs.dh_is_free).val()||-1) +
                    "&exclude_vip_amount=" + ($(_this.$refs.dh_is_vip).val()||-1) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.dhExport_type + 
                    "&exclude_pay_platform=" + _this.exclude_pay_platform
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 进入选择组别
            dhEnterGroup: function() {
                this.c_dh_group_checkboxModel = this.dh_group_checkboxModel;
                this.dh_group_checkboxModel = [];
                this.getDhGroupData();
                this.dh_group_checkboxModel = this.c_dh_group_checkboxModel;
                $('.dh-list').hide();
                $('.dh-group').show();
            },
            // 获取组别列表
            getDhGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.dhShop).val(),
                            "key_word": _this.hzperf_field,
                            "group_name": _this.dh_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.dh_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupDhCheckedAll: function() {
                let _this = this;
                _this.dh_group_allcheck = _this.dh_c_group_allcheck;
                if(!_this.dh_group_allcheck) { // 实现全选
                    _this.dh_group_checkboxModel = [];
                    _this.dh_group_checkboxData.forEach(function(item) {
                        _this.dh_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.dh_group_checkboxModel = [];
                }
            },
            // 返回
            dhGroupBack: function() {
                $('.dh-group').hide();
                $('.dh-list').show();
                this.dh_group_checkboxModel = this.c_dh_group_checkboxModel;
            },
            dhGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.dh_group_checkboxData.forEach(function(item) {
                    _this.dh_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.dh_group_type = arr.join(',');
                $('.dh-group').hide();
                $('.dh-list').show();
            },

            // 打开剔除弹窗
            openExcludePayPlatform: function () {
                let _this = this 
                let c_exclude_pay_platform = this.exclude_pay_platform
                let c_excludePayPlatform_str = this.excludePayPlatform_str
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['金额类型选择', true],
                    area: ['750px', ''], // 宽高
                    content: $(_this.$refs.pay_platform_pop),
                    cancel: function() {
                        _this.exclude_pay_platform = c_exclude_pay_platform
                        _this.excludePayPlatform_str = c_excludePayPlatform_str
                    }
                }, function() {
                    let arr = []
                    _this.exclude_pay_platform.forEach(item => {
                        _this.excludePayPlatform.forEach(v => {
                            if (item == v.id) {
                                arr.push(v.name)
                            }
                        })
                    })
                    _this.excludePayPlatform_str = arr.join(",")
                    layer.closeAll()
                }, function() {
                    _this.exclude_pay_platform = c_exclude_pay_platform
                    _this.excludePayPlatform_str = c_excludePayPlatform_str
                    layer.closeAll()
                });
            },

            handleCheckAllChange: function(val) {
                this.exclude_pay_platform = []
                if (val) {
                    this.excludePayPlatform.forEach(item => {
                        this.exclude_pay_platform.push(item.id)
                    })
                }
                this.checkAllFlag = false;
            },
            handleCheckedPayPlatformChange: function (val) {
                let len = val.length
                this.checkAll = len === this.excludePayPlatform.length
                this.checkAllFlag = len > 0 && len < this.excludePayPlatform.length
            },
        }
    }
</script>
<style lang="less" scoped>
    .dh-list {
        .list-label-x {
            float: left;
            width: 150px;
            padding: 0;
            margin: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            font-weight: normal;
        }
        .list-label-y {
            float: left;
            width: 158px;
            padding: 0;
            margin: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            font-weight: normal;
        }
    }
    /* 组别 */
    .dh-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
    .pay-platform-pop {
        display: none;
        .el-checkbox {
            width: 200px;
            margin: 10px;
        }
    }
</style>